import moment from "moment";
import { Button } from "PFComponents/button";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { Activity } from "PFTypes";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import css from "./prop_node.module.scss";
import { Row } from "./use_cell_data";

type PropNodeProps = {
  row: Row;
  activity: Activity;
  top: number;
  changeTab: (tab: string) => void;
};

export const PropNode = ({ row, activity, top, changeTab }: PropNodeProps) => {
  let valNode: ReactElement | null;
  if (row.id === "bio") {
    valNode = null;
  } else if (row.id === "availability") {
    valNode = <AvailabilityNode activity={activity} changeTab={changeTab} />;
  } else {
    valNode = <CustomFieldNode activity={activity} row={row} />;
  }

  return !top ? null : (
    <div className={css.prop} style={{ top }}>
      {row.display_as}
      <div className={css.propValue}>{valNode}</div>
    </div>
  );
};

type AvailabilityNodeProps = {
  activity: Activity;
  changeTab: (tab: string) => void;
};

const AvailabilityNode = ({ activity, changeTab }: AvailabilityNodeProps) => {
  const { formatDate } = useDateFormatter();
  const { t } = useTranslation("activities");

  const availability = activity.metadata && activity.metadata.availability;

  if (!availability) {
    return null;
  }

  const start = formatDate(moment.min(availability.ranges.map((range) => moment(range.start))));
  const end = formatDate(moment.max(availability.ranges.map((range) => moment(range.end))));

  return (
    <>
      {start}
      {" - "}
      <br />
      {end}
      <br />
      <Button kind="text" text={t("compare.viewAsGantt")} onClick={() => changeTab("availability")} />
    </>
  );
};

type CustomFieldNodeProps = {
  row: Row;
  activity: Activity;
};

const CustomFieldNode = ({ activity, row }: CustomFieldNodeProps) => {
  const { t } = useTranslation("activities");

  const fields = activity.custom_fields;
  const field = row.name && fields && fields.find(({ type: { name } }) => name === row.name);
  const values = field ? field.values : [];
  return (
    <>
      {values.length === 1 && <span>{values[0].text}</span>}
      {values.length > 1 && (
        <Link to={`/activities/${activity.id}`} target="_blank" rel="noopener noreferrer">
          {t("compare.lengthSpecified", { length: values.length })}
        </Link>
      )}
    </>
  );
};
